/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { Quote } from '../../resources';

@Component({
  selector: 'app-page-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input()
  public quote: Quote;
}
